import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog1 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          Every month, you think,
          <br />
          <em>"This time I'll save something."</em>
          <br />
          But at the end of the month, the pocket is empty.
          <br />
          <br />
          Rent, rations, bills… sab paisa khatam.
          <br />
          <br />
          And banks? Complicated forms. Hidden charges.
          <br />
          Sometimes, traditional saving options just feel overwhelming.
        </p>

        <p className="sub-paragraph-heading">
          When the Money Ends Before the Month Does
        </p>
        <p className="sub-paragraph-content">
          You might think, "I'll start saving later, when I earn more."
          <br />
          And that's okay - it's natural to wait for the right moment.
          <br />
          Meanwhile, prices keep rising, and life keeps moving forward.
          <br />
          It's normal to wonder how to stay on track.
          <br />
          It's not just about the money.
          <br />
          It's about feeling secure.
          <br />
          It's about living in peace of mind.
        </p>

        <p className="sub-paragraph-heading">
          Small, Steady Steps,
          <br /> Beat Big, Delayed Plans
        </p>
        <div className="sub-paragraph-content">
          This is where small, manageable savings can make a difference. Even
          tiny amounts, when done consistently, add up over time.
          <br />
          <ul>
            <li style={{ marginBottom: "10px", color: "black" }}>
              Start saving from just ₹1 with digital gold or micro-SIPs
            </li>
            <li style={{ marginBottom: "10px", color: "black" }}>
              Build a habit of regular saving that grows automatically.
            </li>
            <li style={{ marginBottom: "10px", color: "black" }}>
              Track your progress easily, no confusing paperwork or hidden
              charges
            </li>
          </ul>
          <br />
          <a
            href="https://kleio.app.link/download"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#1155cc",
              textDecoration: "underline",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            Begin with just ₹1 - and see how savings grow.
          </a>
          <br />
          <br />
          <span style={{ color: "black", fontSize: "20px" }}>
            The key is to start - no matter how small the step.
          </span>
        </div>

        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>
        <FaqAccordion>
          <h4 className="faq-question">
            How can I start saving if my income is small or irregular?
          </h4>
          <p className="faq-answer">
            Start with very small amounts - even ₹1 daily. Micro-investment apps
            or digital gold SIPs let you save in tiny increments that grow over
            time. The important thing is <b>consistency</b>, not the size of
            each deposit. Over months, your small savings can create real
            financial security.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">
            I keep breaking my savings habit - how do I stay consistent?
          </h4>
          <p className="faq-answer">
            Automate it. Set auto-saves or micro-SIPs so saving happens before
            spending.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">Can I withdraw my savings anytime?</h4>
          <p className="faq-answer">
            Yes. You can redeem digital gold or micro-savings anytime - no
            lock-ins, no penalties.
          </p>
        </FaqAccordion>
        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Blog1;
